var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sl-table',{ref:"table",attrs:{"loading":_vm.loading,"page":_vm.page,"columns":_vm.columns,"data":_vm.data},on:{"on-selection-change":_vm.handleSelect,"on-update":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }